import { useTheme } from '@mui/material';

interface DARSProps {
  isDisabled: boolean;
  isReadOnly: boolean;
}

/**
 * React hook that abstracts a common ternary needed for styling so we can define colors in one place
 */
export const useDisabledAndReadonlyStyling = ({
  isDisabled,
  isReadOnly,
}: DARSProps) => {
  const theme = useTheme();

  if (isReadOnly) {
    return theme.palette.states.readonly;
  } else {
    return isDisabled ? theme.palette.grey[400] : theme.palette.states.default;
  }
};
